import { render } from "src/website-apps/shared/utils/render";
import { CityRoot } from "./root";

render(<CityRoot />);
